// import { BrowseCasesComponent } from './views/browse-cases/browse-cases.component';
import { UsermenuComponent } from './views/usermenu/usermenu.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Import Containers
import { DefaultLayoutComponent } from './containers';

import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';
import { LoginComponent } from './views/login/login.component';
import { RegisterComponent } from './views/register/register.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: '',
    redirectTo: 'manage-company',
    pathMatch: 'full',
  },
  {
    path: '',
    redirectTo: 'manage-marshal',
    pathMatch: 'full',
  },
  {
    path: '404',
    component: P404Component,
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '500',
    component: P500Component,
    data: {
      title: 'Page 500'
    }
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login Page'
    }
  },
  // {
  //   path: 'browsecases',
  //   component: BrowseCasesComponent,
  //   data: {
  //     title: 'User Menu'
  //   }
  // },
  {
    path: 'register',
    component: RegisterComponent,
    data: {
      title: 'Register Page'
    }
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: 'Login'
    },
    children: [
      {
        path: 'base',
        loadChildren: './views/base/base.module#BaseModule'
      },
      {
        path: 'buttons',
        loadChildren: './views/buttons/buttons.module#ButtonsModule'
      },
      {
        path: 'charts',
        loadChildren: './views/chartjs/chartjs.module#ChartJSModule'
      },
      {
        path: 'dashboard',
        loadChildren: './views/dashboard/dashboard.module#DashboardModule'
      },
      {
        path: 'addcompany',
        loadChildren: './views/company/manage-company/manage-company.module#ManageCompanyModule'
      },
      {
        path: 'managecompany',
        loadChildren: './views/company/browse-company/browse-company.module#BrowseCompanyModule'
      },
      {
        path: 'login',
        loadChildren: './views/appusers/login/login.module#LoginModule'
      },
      {
        path: 'addmarshals',
        loadChildren: './views/marshal/manage-marshals/manage-marshals.module#ManageMarshalsModule'
      },
      {
        path: 'managemarshals',
        loadChildren: './views/marshal/browse-marshals/browse-marshals.module#BrowseMarshalsModule'
      },
      {
        path: 'addlawyer',
        loadChildren: './views/lawyer/manage-lawyer/manage-lawyer.module#ManageLawyerModule'
      },
      {
        path: 'managelawyer',
        loadChildren: './views/lawyer/browse-lawyer/browse-lawyer.module#BrowseLawyerModule'
      },
      {
        path: 'MLLinks',
        loadChildren: './views/marshal-lawyer/marshal-lawyer.module#MarshalLawyerModule'
      },
      {
        path: 'browsecases',
        loadChildren: './views/browse-cases/browse-cases.module#BrowseCasesModule'
      },
      {
        path: 'fileupload',
        loadChildren: './views/fileupload/fileupload.module#FileuploadModule'
      },
      {
        path: 'newcaseslog',
        loadChildren: './views/newcaselog/newcaselog.module#NewcaselogModule'
      },
      {
        path: 'msdreports',
        loadChildren: './views/msd-reports/msd-reports.module#MsdReportsModule'
      },
      {
        path: 'lawyerlinkmenu',
        loadChildren: './views/lawyerlinkmenu/lawyerlinkmenu.module#LawyerlinkmenuModule'
      },
      {
        path: 'userbrowsecases',
        loadChildren: './views/browse-cases/browse-cases.module#BrowseCasesModule'
      },
      {
        path: 'manageappusers',
        loadChildren: './views/appusers/manage-appusers/manage-appusers.module#ManageAppusersModule'
      },
      {
        path: 'icons',
        loadChildren: './views/icons/icons.module#IconsModule'
      },
      {
        path: 'notifications',
        loadChildren: './views/notifications/notifications.module#NotificationsModule'
      },
      {
        path: 'theme',
        loadChildren: './views/theme/theme.module#ThemeModule'
      },
      {
        path: 'widgets',
        loadChildren: './views/widgets/widgets.module#WidgetsModule'
      }
    ]
  }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}
